export const Marquee = ({ items }) => {
  const text = items.join("  \u2022  ") + "  \u2022  ";
  return (
    <div className="overflow-hidden border-y border-gold-400/15 bg-navy-900/60 py-5" data-testid="marquee">
      <div className="marquee-track font-serif text-gold-200/70 tracking-[0.35em] uppercase text-sm">
        <span className="pr-8">{text}</span>
        <span className="pr-8">{text}</span>
      </div>
    </div>
  );
};
